import { SpaceBetween } from "@cloudscape-design/components-themed";
import { MerchantInfo } from "./MerchantInfo";
import { ApplicantCompany } from "./ApplicantCompany";
import { ReferenceGroup } from "./ReferenceGroup";
import { BankAccount } from "./BankAccount";
import { PaymentCycle } from "./PaymentCycle";
import { PaymentTargetCompany } from "./PaymentTargetCompany";
import { Footer } from "./Footer";
import { useContext, useEffect, useState } from "react";
import { BankAccountInquiryContext } from "../../pages/BankAccountsInquiry";
import { UpdatingContentModal } from "./UpdatingContentModal";
import { IErrMsg } from "./constants";
import { BankAccountsUpdateRequest } from "../../features/api-interfaces";
import { CODE_MASTER } from "../default-constants";
import { isEmpty } from "lodash";
import { useLocation } from "react-router-dom";

/**
 * 入金口座情報照会・更新
 */
export const Main = () => {
  const { pathname } = useLocation();
  const { companyContractBankAccountNo, apiResponse, isFetching } = useContext(
    BankAccountInquiryContext
  )!;
  const updatingInfo = apiResponse?.updatingInfo;
  const applyingDate = apiResponse?.applyingDate;
  const referenceGroup = apiResponse?.prodInfo.referenceGroup;
  const bankAccount = apiResponse?.prodInfo.bankAccount;
  const paymentCycleCode = apiResponse?.prodInfo.paymentCycleCode;
  const paymentTargetCompany = apiResponse?.prodInfo.paymentTargetCompany;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errMsg, setErrMsg] = useState<IErrMsg>({});
  const [isUpdate, setIsUpdate] = useState(false);
  const [request, setRequest] = useState<BankAccountsUpdateRequest>({
    companyContractBankAccountNo: 0,
    notificationEmail: "",
    fnnInsMthStrCd: "",
    fnnInsMthStrNm: "",
    fnnInsBrnCd: "",
    fnnInsBrnNm: "",
    bankAccountType: 0,
    bankAccountNumber: "",
    bankAccountHolderKana: "",
    paymentCycleCode: "",
    corporateNumber: "",
    companyName: "",
    companyNameKana: "",
    postalCode: "",
    paymentTargetCompanyAddress1: "",
    paymentTargetCompanyAddress2: "",
    paymentTargetCompanyAddress1Kana: "",
    phoneNumber: "",
  });

  useEffect(() => {
    setIsUpdate(pathname.includes("update"));
  }, [pathname]);

  useEffect(() => {
    if (!isEmpty(apiResponse)) {
      setRequest({
        companyContractBankAccountNo,
        notificationEmail: referenceGroup?.beforeNotificationEmail ?? "",
        fnnInsMthStrCd: bankAccount?.fnnInsMthStrCd ?? "",
        fnnInsMthStrNm: bankAccount?.fnnInsMthStrNm ?? "",
        fnnInsBrnCd: bankAccount?.fnnInsBrnCd ?? "",
        fnnInsBrnNm: bankAccount?.fnnInsBrnNm ?? "",
        bankAccountType:
          bankAccount?.bankAccountType ??
          Number(CODE_MASTER["BANK_ACCOUNT_TYPE"][0].value),
        bankAccountNumber: bankAccount?.bankAccountNumber ?? "",
        bankAccountHolderKana: bankAccount?.bankAccountHolderKana ?? "",
        paymentCycleCode:
          paymentCycleCode ?? CODE_MASTER["PAYMENT_CYCLE_CODE"][0].value,
        corporateNumber: paymentTargetCompany?.corporateNumber ?? "",
        companyName: paymentTargetCompany?.companyName ?? "",
        companyNameKana: paymentTargetCompany?.companyNameKana ?? "",
        postalCode: paymentTargetCompany?.postalCode ?? "",
        paymentTargetCompanyAddress1: paymentTargetCompany?.address ?? "",
        paymentTargetCompanyAddress2:
          paymentTargetCompany?.addressDetails ?? "",
        paymentTargetCompanyAddress1Kana:
          paymentTargetCompany?.addressKana ?? "",
        phoneNumber: paymentTargetCompany?.phoneNumber ?? "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiResponse, isUpdate]);

  return (
    <>
      <SpaceBetween direction="vertical" size="l">
        <MerchantInfo
          updatingInfo={updatingInfo}
          applyingDate={applyingDate}
          merchantInfo={apiResponse?.prodInfo.merchantInfo}
          setIsModalOpen={setIsModalOpen}
        />
        <ApplicantCompany
          applicantCompany={apiResponse?.prodInfo.applicantCompany}
        />
        <ReferenceGroup
          referenceGroup={referenceGroup}
          isModalOpen={isModalOpen}
          isUpdate={isUpdate}
          request={request}
          setRequest={setRequest}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
        />
        <BankAccount
          bankAccount={bankAccount}
          isModalOpen={isModalOpen}
          isUpdate={isUpdate}
          request={request}
          setRequest={setRequest}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
        />
        <PaymentCycle
          paymentCycleCode={paymentCycleCode}
          isModalOpen={isModalOpen}
          isUpdate={isUpdate}
          request={request}
          setRequest={setRequest}
        />
        <PaymentTargetCompany
          isFetching={isFetching}
          paymentTargetCompany={paymentTargetCompany}
          isModalOpen={isModalOpen}
          isUpdate={isUpdate}
          request={request}
          setRequest={setRequest}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
        />
        <Footer
          isFetching={isFetching}
          companyContractBankAccountNo={companyContractBankAccountNo}
          updatingInfo={updatingInfo}
          applyingDate={applyingDate}
          isUpdate={isUpdate}
          setIsUpdate={setIsUpdate}
          request={request}
          setErrMsg={setErrMsg}
        />
      </SpaceBetween>
      <UpdatingContentModal
        isFetching={isFetching}
        apiResponse={apiResponse}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        request={request}
        setRequest={setRequest}
        errMsg={errMsg}
        setErrMsg={setErrMsg}
      />
    </>
  );
};
